import React, { useState } from 'react';

const AddFAQForm = ({ onAddFAQ }) => {
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    category: 'general'
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAddFAQ(formData);
    setFormData({
      question: '',
      answer: '',
      category: 'general'
    });
  };

  return (
    <div className="card">
      <h2>➕ Добавить FAQ</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="question">Вопрос:</label>
          <textarea
            id="question"
            name="question"
            placeholder="Введите вопрос..."
            value={formData.question}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="answer">Ответ:</label>
          <textarea
            id="answer"
            name="answer"
            placeholder="Введите ответ..."
            value={formData.answer}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-footer">
          <div className="form-group category-group">
            <label htmlFor="category">Категория:</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="general">Общие</option>
              <option value="integration">Интеграция</option>
              <option value="search">Поиск</option>
              <option value="technical">Технические</option>
              <option value="support">Поддержка</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary">Добавить FAQ</button>
        </div>
      </form>
    </div>
  );
};

export default AddFAQForm; 